import { useTranslation } from 'react-i18next';
import { EditOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useUpdateClientInsuranceDates } from 'api/clients/use-update-client-insurance-dates';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { ClientInsuranceFileControl } from 'components/clients/client-insurance/components/client-insurance-file-control';
import type { IInsuranceFormValues } from 'components/clients/client-insurance/components/client-insurance-modal';
import { ClientInsuranceModalWithButton } from 'components/clients/client-insurance/components/client-insurance-modal-with-button';
import type { IEditClientInsuranceDatesProps } from './types';

const EditClientInsuranceDatesComponent = (props: IEditClientInsuranceDatesProps) => {
  const { buttonLabel, clientId, insurance } = props;
  const { t } = useTranslation('client');

  const { mutateAsync: updateDates, isLoading: isUpdating } = useUpdateClientInsuranceDates(clientId, insurance.id);

  const handleUpdate = async ({ validityPeriod }: IInsuranceFormValues) => {
    await updateDates({
      validFrom: validityPeriod[0].format('YYYY-MM-DD'),
      validTo: validityPeriod[1].format('YYYY-MM-DD'),
    });
  };

  return (
    <ClientInsuranceModalWithButton
      buttonLabel={buttonLabel === undefined ? t('insurance_edit_dates') : buttonLabel}
      buttonProps={{ icon: <EditOutlined /> }}
      title={t('insurance_edit_dates_title')}
      submitText={t('insurance_save_changes')}
      fileLabel={t('insurance_file')}
      initialValidityPeriod={[dayjs(insurance.validFrom), dayjs(insurance.validTo)]}
      fileContent={
        <ClientInsuranceFileControl
          clientId={clientId}
          insuranceId={insurance.id}
          fileName={insurance.fileName}
          mimeType={insurance.mimeType}
        />
      }
      isSubmitting={isUpdating}
      onSubmit={handleUpdate}
    />
  );
};

export const EditClientInsuranceDates = withRoleGuard<IEditClientInsuranceDatesProps>(
  EditClientInsuranceDatesComponent,
  [UserRole.admin, UserRole.assistant, UserRole.customer_manager],
);
